import { Component, OnInit } from '@angular/core';
import { VideoGridComponent } from 'src/app/features/video/view/video-grid/video-grid.component';
import { SearchBarComponent } from "../../fragments/search-bar/search-bar.component";
import { VideoStreamingService } from 'src/app/features/video/controller/video-streaming.service';
import { VideoSearchResultListPaginated } from 'src/app/features/video/model/video-search-result.model';
import { VideoFilterComponent } from 'src/app/features/handball/video-quering/view/video-filter/video-filter.component';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { VideoSortByComponent } from 'src/app/features/handball/video-quering/view/video-sort-by/video-sort-by.component';
import { RfebmIconButtonComponent } from "../../ui/atoms/rfebm-icon-button/rfebm-icon-button.component";


@Component({
  selector: 'app-analysis',
  templateUrl: 'analysis.component.html',
  styleUrl: 'analysis.component.scss',
  standalone: true,
  imports: [CommonModule, VideoGridComponent, SearchBarComponent, VideoFilterComponent, VideoSortByComponent, RfebmIconButtonComponent],
})
export class AnalysisComponent implements OnInit {


  protected searchQuery: string = '';
  protected videoSearchResultListPaginated: VideoSearchResultListPaginated = null;
  protected showFilter: boolean = false;
  protected showSortBy: boolean = false;

  protected isFiltersBeingApplied: boolean = false;
  protected isSortingBeingApplied: boolean = false;

  constructor(
    private router: Router,
    private videoStreamingService: VideoStreamingService
  ) { }

  ngOnInit() {
    this.refreshVideoList();
  }

  protected onSearch(text: string) {
    this.searchQuery = text;
    this.refreshVideoList();
  }

  protected async applyFilters($event: any) {

    this.isFiltersBeingApplied = $event !== null;

    this.showFilter = false;
    this.videoSearchResultListPaginated = null;
    await new Promise((resolve) => setTimeout(resolve, 1000));
    await this.refreshVideoList();
  }

  protected async applySortBy($event: any) {
    this.isSortingBeingApplied = $event !== null;

    this.showSortBy = false;
    this.videoSearchResultListPaginated = null;
    await new Promise((resolve) => setTimeout(resolve, 1000));
    this.refreshVideoList();
  }

  protected async setFilterVisible(nextState: boolean) {

    if (nextState === this.showFilter) {
      return;
    }

    if (nextState) {
      this.setSortByVisible(false);
    }

    if (nextState) {
      document.querySelector('.filter-overlay').classList.remove('after-hide');
      await new Promise((resolve) => setTimeout(resolve));
    }

    this.showFilter = nextState;

    if (!nextState) {
      await new Promise((resolve) => setTimeout(resolve, 100));
      document.querySelector('.filter-overlay').classList.add('after-hide');
    }
  }

  protected async setSortByVisible(nextState: boolean) {

    if (nextState === this.showSortBy) {
      return;
    }

    if (nextState) {
      this.setFilterVisible(false);
    }

    if (nextState) {
      document.querySelector('.sortby-overlay').classList.remove('after-hide');
      await new Promise((resolve) => setTimeout(resolve));
    }

    this.showSortBy = nextState;

    if (!nextState) {
      await new Promise((resolve) => setTimeout(resolve, 100));
      document.querySelector('.sortby-overlay').classList.add('after-hide');
    }
  }

  private async refreshVideoList() {
    this.videoSearchResultListPaginated = null;


    if (!this.searchQuery) {
      this.videoSearchResultListPaginated = await this.videoStreamingService.searchVideos();
      return;
    }

    this.videoSearchResultListPaginated = await this.videoStreamingService.searchVideos({
      searchQuery: this.searchQuery,
    });

  }

  protected onUploadVideo() {
    this.router.navigate(['/upload']);
  }

}
